module.exports = __webpack_public_path__ + "static/media/nutrition.4add4021.png";